import { Component } from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "../../translate/translate.service";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="isLoad"></loading>
			
			<div class="btn-group" role="group">
				<button
					*ngFor="let v of ['Active', 'Renew', 'Expired', 'Free', 'Removed']"
					type="button"
					[ngClass]="[
						'btn',
						'btn-default',
						v == status ? 'active' : ''
					]"
					(click)="status=v"
					[attr.data-sectionvalue]="v">
					{{ v }} ({{(stats | filterBy: 'status' : v).length}})
				</button>
			</div>
			
			<table class="table table-bordered">
				<thead>
					<tr class="info">
						<th colspan="2">
							status
						</th>
						
						<th>
							name
						</th>
						
						<th>
							expired date
						</th>
					</tr>
				</thead>
				
				<tbody>
					<tr *ngFor="let stat of stats | filterBy: 'status' : status">
						<td colspan="2">
							{{ stat.status }}
						</td>
						
						<td>
							{{ stat.name }}
						</td>
						
						<td>
							{{ stat.expirationDate }}
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
	`
})
export class BuyingChartDetail extends InfoModalComponent {
	isLoad: boolean = false;
	status: string = 'Active';
	
	public stats = [];

	constructor(public activeModal: NgbActiveModal, public translate: TranslateService) {
		super(activeModal);
	}
	
	
	
	f1(item) {
		console.log('f1', item, this.status)
		return item;
	}


	ok() {
		this.close();
	}
}
